import { OdataManager } from '@/api/odata/odata-manager';
import { RegisterIssueAttachment } from '@/api/model/interfaces';

export default class RegisterIssueAttachmentOdata extends OdataManager<RegisterIssueAttachment> {}
